import React from 'react';
import { gql } from '@common/hooks';
import { Link, TimeWithTimeZone, Text } from '@common/components';
import { CandidateOfferCardItem } from '@applicant-flow/components';
import { OFFER_CONFIRMATION_DRAWER_INFO_FRAGMENT } from '@applicant-flow/graphql';
import { buildDialogUrl } from '@common/services';

const OFFER_STATE_MAP = {
  offered: 'Offer',
  rejected: 'Offer Rejected',
  accepted: 'Accepted',
  retracted: 'Offer Retracted',
  change_requested: 'Change Requested',
};

type OfferStateMapKeyType = keyof typeof OFFER_STATE_MAP;

type Props = {
  offer: {
    id: string;
    state: OfferStateMapKeyType;
    createdAt: string;
  };
};

export function CandidateOfferListItem({ offer }: Props) {
  const offerConfirmationDrawerUrl = buildDialogUrl(
    'offer-confirmation-drawer',
    { props: { offerId: offer.id } }
  );

  return (
    <CandidateOfferCardItem>
      <Link to={offerConfirmationDrawerUrl}>
        <Text bold color="elm">
          {getOfferStateLabel(offer.state)}
        </Text>
      </Link>
      <div>
        Received{' '}
        <TimeWithTimeZone date={offer.createdAt} variant="short_format" />
      </div>
    </CandidateOfferCardItem>
  );
}

function getOfferStateLabel(key: OfferStateMapKeyType) {
  const label = OFFER_STATE_MAP[key];

  if (!label) {
    console.error(`Offer: offer state key "${key}" unknown`);
    return '';
  }

  return label;
}

CandidateOfferListItem.fragments = {
  OfferListInfo: gql`
    fragment OfferListInfo on Offer {
      id
      createdAt
      state
      staffingRequestApplication {
        id
        staffingRequest {
          id
          externalId
          staffingRequestType
          role {
            id
            abbreviation
          }
        }
      }
      ...OfferConfirmationDrawerInfo
    }
    ${OFFER_CONFIRMATION_DRAWER_INFO_FRAGMENT}
  `,
};
